import { RootState } from "src";
import { PropertyAccessCredential } from "src/common/types";

export const selectValidUserCodes = (state: RootState) => {
  const residentCodes = [];
  const residentCredentials = [];
  const staffCodes = [];
  const staffCredentials = [];
  const propertyGuestCodes = [];
  const unitGuestCodes = [];

  if (state.property.residents) {
    for (const resident of state.property.residents) {
      if (resident.property_access_credential) {
        residentCodes.push(resident.property_access_credential.code);
      }

      residentCredentials.push(
        ...resident.property_credentials.map(
          (c: PropertyAccessCredential) => c.code
        )
      );
    }
  }

  if (state.property.staff) {
    for (const staff of state.property.staff) {
      if (staff.property_access_credential) {
        staffCodes.push(staff.property_access_credential.code);
      }

      staffCredentials.push(
        ...staff.property_credentials.map(
          (c: PropertyAccessCredential) => c.code
        )
      );
    }
  }

  if (state.property.propertyGuests) {
    for (const guest of state.property.propertyGuests) {
      if (guest?.propertyAccessCredential.active) {
        propertyGuestCodes.push(guest.propertyAccessCredential.code);
      }
    }
  }

  if (state.property.unitGuests) {
    for (const unitGuest of state.property.unitGuests) {
      if (
        unitGuest.propertyAccessCredential &&
        unitGuest.propertyAccessCredential.active
      ) {
        unitGuestCodes.push(unitGuest.propertyAccessCredential.code);
      }
    }
  }

  return [
    ...residentCodes,
    ...residentCredentials,
    ...staffCodes,
    ...staffCredentials,
    ...propertyGuestCodes,
    ...propertyGuestCodes,
    ...unitGuestCodes,
  ];
};
